import { WorkflowObjectState, Query, Predicate, ErrorFlow } from 'olympe';
import React, { useState, useRef, useEffect } from 'react';
import { getLogger } from '@olympeio/core';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import {contriesList} from '../../section_sf/Utils.js'
import { getIcon } from '../../shared/utils/_icons.jsx';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import { updateProperty } from '../../shared/datagrid/DataGridRenderers.jsx';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {
    getCurrentWorkflow,
    workflowStatesForApplyButtonDisabled,
} from '../../../common/section_bcp/BcpWorkflowAuthorizations.js';
import BCP from '../../../common/section_bcp/DM_BCP';
import { AlternativeVendorDropdown } from '../../section_bcp/renderers/AlternativeVendorDropdown.jsx';
import { executeLambda } from '../../../node/BackendData/LambdaExecutor';
import { useDebounce } from '../../shared/_helpers';
import { removeZeros } from '../mass_import/utils.js';
import { padLeftWithZerosFinalDigits } from '../mass_import/utils.js';
import { Tooltip , Typography} from '@mui/material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        height: '320px',
        width: '1024px'
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialogContent-root::-webkit-scrollbar': {
        display: 'masonry !important',
    },
}));

/**
 * @param {Object} props
 * @return {JSX.Element}
 */

export const EditVendorDialog = (props) => {
    const logger = getLogger('EditVendorDialog');
    let {
        context,
        bcpRequest,
        closePopup,
        setRefreshMe,
        refreshMe,
        refreshLine,
    } = props;
    const [country, setCountry] = useState(bcpRequest.get(BCP.vdetCountryProp));
    const [successMessage, setSuccessMessage] = useState(false)
    const [vendorName, setVendorName] = useState(bcpRequest.get(BCP.vdetNameProp));
    const [vendorAddress, setVendorAddress] = useState(bcpRequest.get(BCP.vdetAddressProp));
    const [vendorCity, setVendorCity] = useState(bcpRequest.get(BCP.vdetCityProp));
    const [vendorEmail, setVendorEmail] = useState(bcpRequest.get(BCP.vdetEmailProp));
    const [vendorContactNo, setVendorContactNo] = useState(bcpRequest.get(BCP.vdetContactNumberProp));
    const [alternateVendor,] = useState(bcpRequest.get(BCP.alternativeVendorCodeProp));
    const [mvLinkedVendor,] = useState(bcpRequest.get(BCP.mainVendorLinkedAltVendorProp));
    const [disableVendor, setDisableVendor] = useState(false) 
    const [alternateVendorList, setAlternateVendorList] = useState([])
    const [mvLinkedList, setMvLinkedList] = useState([])   

    const [countryList,] = useState(contriesList);

    //const [finalResultAlternative, setFinalResultAlternative] = useState();
    const fetchAlternativeVendors = props.context.get('Fetch Alternative Vendors');
    const debouncedTextInput = useDebounce(textInput, 1000);
    const [textInput, setTextInput] = useState(props.initialValue);
    const NO_OPTIONS_LABEL = 'No options';

    // This function will help save(create/update) Vendor data for a specific BCP request
    const saveVendorData = async () => {
        try {
            const queryResult = await Query.instancesOf(BCP)
                .filter(
                    Predicate.and(
                        Predicate.equals(BCP.materialIdProp, props.materailId),
                        Predicate.equals(BCP.plantIdProp, props.plantID)
                    )
                )
                .execute();
            logger.info("***After updating database values for vendorName, vendorAddress,country, vendorCity, vendorAddress, vendorEmail, alternateVendor, mvLinkedVendor*", vendorName, vendorAddress,
                country, vendorCity, vendorAddress, vendorEmail, alternateVendor, mvLinkedVendor);
            let bcpRequest = queryResult.toArray()?.[0]
            updateProperty(
                context,
                bcpRequest,
                BCP.vdetNameProp,
                vendorName || ''
            );
            updateProperty(
                context,
                bcpRequest,
                BCP.vdetAddressProp,
                vendorAddress || ''
            );
            updateProperty(
                context,
                bcpRequest,
                BCP.vdetCountryProp,
                country || ''
            );
            updateProperty(
                context,
                bcpRequest,
                BCP.vdetCityProp,
                vendorCity || ''
            );
            updateProperty(
                context,
                bcpRequest,
                BCP.vdetContactNumberProp,
                vendorContactNo || ''
            );
            updateProperty(
                context,
                bcpRequest,
                BCP.vdetEmailProp,
                vendorEmail || ''
            );
            setSuccessMessage(true)
            setRefreshMe(true)
            refreshLine()
        } catch (error) {
            logger.error("Error happened during update of BCP request for vendor details", error)
        }
    }

    const dialogRef = useRef(null);

    // SQA link list - to refer the document

    const currentWorkflowState = getCurrentWorkflow(bcpRequest, context)?.get(
        WorkflowObjectState.stateProp
    );



    // Create the react equivalent for the dropndown
    const handleClose = () => {
        setRefreshMe(false);
    };

    useEffect(() => {
        if (dialogRef.current) {
            // Example: remove a specific property
            dialogRef.current.style.removeProperty('display');
        }
        if (refreshMe) {
            handleDialogOpen()
        }
    }, []);

    const handleChange = (event) => {
        setCountry(event.target.value);
    };

    const handleDialogOpen = () => {
        //execute lambda
        fetchData()
    }

    const fetchData = async () => {
        const customErrorCode = 2311052908;
        const searchInputAlternate = alternateVendor !== null ? alternateVendor : debouncedTextInput?.split('-')[0].trim();
        const searchInputMVLinked = mvLinkedVendor !== null ? mvLinkedVendor : debouncedTextInput?.split('-')[0].trim();

        try {
            if (alternateVendor) {
                const resultsString = await executeLambda(props.context, fetchAlternativeVendors, [props.bcpRequest, searchInputAlternate], customErrorCode);
                if (resultsString instanceof ErrorFlow) {
                    const msg = resultsString.getMessage();
                    props.context.set('Error information', { code: 2311492908, message: msg });
                    props.context.trigger('Open Error Popup');
                    console.error(`Alternative Vendor Dropdown error: ${msg}`);
                    return;
                }


                const results = JSON.parse(resultsString).results.map(value => {
                    return {
                        value: removeZeros(value.vendorSite) + "-" + value.vendorSiteName, label: removeZeros(value.vendorSite) + "-" + value.vendorSiteName
                    };
                });

                setAlternateVendorList(results.length > 0 ? results : [{ label: NO_OPTIONS_LABEL, value: '' }]);

            }
            if (mvLinkedVendor) {
                const resultsString = await executeLambda(props.context, fetchAlternativeVendors, [props.bcpRequest, searchInputMVLinked], customErrorCode);
                if (resultsString instanceof ErrorFlow) {
                    const msg = resultsString.getMessage();
                    props.context.set('Error information', { code: 2311492908, message: msg });
                    props.context.trigger('Open Error Popup');
                    console.error(`Alternative Vendor Dropdown error: ${msg}`);
                    return;
                }


                const results = JSON.parse(resultsString).results.map(value => {
                    return {
                        value: removeZeros(value.vendorSite) + "-" + value.vendorSiteName, label: removeZeros(value.vendorSite) + "-" + value.vendorSiteName
                    };
                });
                setMvLinkedList(results.length > 0 ? results : [{ label: NO_OPTIONS_LABEL, value: '' }]);
            }

        } catch (e) {

        } finally {

        }
    }

    //disable vendor details if alt vendor is present
    const checkAltVendor = (val) => {
        setDisableVendor(val !== null && val !== "")
    }

    // Set notification stage to Previous state based on BPPmEmail and BuildBCPQAEmail logic

    return (
        <BootstrapDialog
            ref={dialogRef}
            open={refreshMe}
            onClose={handleClose}
            scroll='paper'
            aria-label='delete-confirmation-dialog'>
            <DialogTitle
                sx={{
                    color: '#f19100',
                    width: '38.25rem',
                    fontSize: '2rem',
                    alignContent: 'center',
                    textAlign: 'center',
                }}>
                Update Vendor Data
            </DialogTitle>
            <IconButton
                aria-label='close'
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}>
                <CloseIcon />
            </IconButton>


            <DialogContent dividers style={{ fontSize: '1.2rem', height: 'max-content' }}>
                <Grid container spacing={1}>
                    <React.Fragment>
                        <Grid item xs={12} sm={12} lg={12} md={12}>
                            {successMessage && <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                Vendor Details updated successfully !!
                            </Alert>}
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'Alternate Vendor'}
                          <Tooltip title={
                                <React.Fragment>
                                    <em>{"The alternative vendor site number is a critical input for the BCP request workflow for the workflow closure. Without this input, the workflow could not detect if the QIR based on the alternative vendor site has been created."}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>                          </Grid>
                        <Grid item xs={4} sm={4} lg={4} md={4}>
                            <AlternativeVendorDropdown
                                context={context}
                                bcpRequest={bcpRequest}
                                onChange={(newVendor) => {
                                    logger.info("New Vendor for alternate vendor", newVendor.value)
                                    const vendorVal = newVendor?.value?.slice(0, newVendor.value.indexOf('-')) || null
                                    checkAltVendor(vendorVal)
                                    updateProperty(context, bcpRequest, BCP.alternativeVendorCodeProp, padLeftWithZerosFinalDigits(vendorVal, 10));
                                }}
                                initialValue={alternateVendor || ''}
                                disabled={false}
                                property={BCP.alternativeVendorCodeProp}
                                type={'AlternativeVendorDD'}
                                setDisableVendor={setDisableVendor}
                                setAlternateVendorList={setAlternateVendorList}
                                alternateVendorList={alternateVendorList}


                            />
                        </Grid>
                        <Grid item xs={5} sm={5} lg={5} md={5}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'MV Linked'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Input main vendor number that is linked to the alternative vendor site."}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={4} sm={4} lg={4} md={4}>
                            <AlternativeVendorDropdown
                                context={context}
                                bcpRequest={bcpRequest}
                                onChange={(newVendor) => {
                                    const vendorVal = newVendor?.value?.slice(0, newVendor.value.indexOf('-')) || null
                                    console.log(" New VENDOR FOR mv lINKED VENDOR", newVendor.value)
                                    checkAltVendor(vendorVal)
                                    updateProperty(context, bcpRequest, BCP.mainVendorLinkedAltVendorProp, padLeftWithZerosFinalDigits(vendorVal, 10));
                                }}
                                initialValue={mvLinkedVendor || ''}
                                disabled={false}
                                property={BCP.mainVendorLinkedAltVendorProp}
                                type={'MVLinkedDD'}
                                setDisableVendor={setDisableVendor}
                                setMvLinkedList={setMvLinkedList}
                                mvLinkedList={mvLinkedList}

                            />
                        </Grid>
                        <Grid item xs={5} sm={5} lg={5} md={5}>
                            &nbsp;
                        </Grid>

                        <Grid item xs={12} sm={12} lg={12} md={12}>
                            <Divider></Divider>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12} md={12}>
                            <Alert severity='info' sx={{
                                width: '35.75rem',
                                display: 'flex',
                                color: 'black',
                                padding: '0.25rem 0.5rem'
                            }}>
                                <span>For new alternative vendor sites without a vendor number, please fill in all the below fields:</span>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12} md={12}>
                            <Divider></Divider>
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'Vendor Name'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} md={6}>
                            <TextField size="small" label="" variant="outlined"
                                inputProps={{
                                    style: {
                                        height: "1.25rem", width: "18.75rem",
                                    },
                                    autoComplete: 'new-password',
                                    form: {
                                        autoComplete: 'off',
                                    },
                                }}
                                value={vendorName == null ? '' : vendorName}
                                autoComplete='false'
                                disabled={disableVendor}
                                onChange={(event) => {
                                    setVendorName(event.target.value)
                                }} />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'Vendor Address'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} md={6}>
                            <TextField multiline
                                inputProps={{
                                    style: {
                                        height: "50px", width: "18.75rem",
                                    },
                                    autoComplete: 'new-password',
                                    form: {
                                        autoComplete: 'off',
                                    }
                                }}
                                label="" variant="outlined"
                                value={vendorAddress == null ? '' : vendorAddress}
                                disabled={disableVendor}
                                onChange={(event) => {
                                    setVendorAddress(event.target.value)
                                }} />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'Vendor Country'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} md={6}>
                            <div sx={{ height: "1.25rem", width: "18.75rem" }}>
                                <FormControl >
                                    <Select
                                        labelId="demo-simple-select-autowidth-label"
                                        id="demo-simple-select-autowidth"
                                        value={country || ""}
                                        disabled={disableVendor}
                                        onChange={handleChange}
                                        autoWidth
                                        displayEmpty
                                    >
                                        {countryList?.map((element, index) => {
                                            return (<MenuItem value={element} key={index}>{element}</MenuItem>)
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3} >
                            {'Vendor City'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} md={6}>
                            <TextField size="small" inputProps={{
                                style: {
                                    height: "1.25rem", width: "18.75rem",
                                }, autoComplete: 'new-password',
                                form: {
                                    autoComplete: 'off',
                                }
                            }} label="" variant="outlined"
                                value={vendorCity == null ? '' : vendorCity}
                                disabled={disableVendor}
                                onChange={(event) => {
                                    setVendorCity(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>

                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'Vendor Contact Number'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} md={6}>
                            <TextField size="small" inputProps={{
                                style: {
                                    height: "1.25rem", width: "18.75rem",
                                }, autoComplete: 'new-password',
                                form: {
                                    autoComplete: 'off',
                                }
                            }} label="" variant="outlined"
                                value={vendorContactNo == null ? '' : vendorContactNo}
                                disabled={disableVendor}
                                onChange={(event) => {
                                    setVendorContactNo(event.target.value)
                                }} />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>&nbsp;</Grid>
                        <Grid item xs={3} sm={3} lg={3} md={3}>
                            {'Vendor Email'}
                            <Tooltip title={
                                <React.Fragment>
                                    <em>{"Provide this input only if the alternative vendor site is totally new and does have a vendor number"}</em>
                                </React.Fragment>
                            }>
                           {getIcon("Info", true, {
                                style: { minWidth: "25px" },
                            })}</Tooltip>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6} md={6}>
                            <TextField size="small" inputProps={{
                                style: {
                                    height: "1.25rem", width: "18.75rem",
                                }, autoComplete: 'new-password',
                                form: {
                                    autoComplete: 'off',
                                }
                            }} label="" variant="outlined"
                                value={vendorEmail == null ? '' : vendorEmail}
                                disabled={disableVendor}
                                onChange={(event) => {
                                    setVendorEmail(event.target.value)
                                }} />
                        </Grid>
                    </React.Fragment>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        saveVendorData()
                        setTimeout(function () {
                            closePopup();
                        }, 3000);
                    }}
                    variant='contained'
                    size='medium'
                    className={'update-QA-apply-changes-button-vendor'}
                    startIcon={getIcon('Save')}
                    disabled={workflowStatesForApplyButtonDisabled.includes(
                        currentWorkflowState
                    )}>
                    Save Vendor data
                </Button>
            </DialogActions>
        </BootstrapDialog>
    );
};
